import { take, fork, all } from 'redux-saga/effects';
import { apiTask } from '../../app/sagas';
import { api } from '../../app/api';
import * as actions from './simulatedContentMapActions';

export const reproveContentMapAbilityTask = apiTask(
  actions.REPROVE_CONTENT_MAP_HABILITY,
  api.post,
  '/evaluation-system/disapproveContentmapAbility.php',
);

export const approveContentMapAbilityTask = apiTask(
  actions.APPROVE_CONTENT_MAP_HABILITY,
  api.post,
  '/evaluation-system/approveContentmapAbility.php',
);

export const editContentMapAbilityTask = apiTask(
  actions.EDIT_CONTENT_MAP_HABILITY,
  api.post,
  '/evaluation-system/editContentmapAbilities.php',
);

export const addContentMapAbilityTask = apiTask(
  actions.ADD_CONTENT_MAP_HABILITY,
  api.post,
  '/evaluation-system/addContentmapAbilities.php',
);

export const getAbilitiesTask = apiTask(
  actions.GET_HABILITIES,
  api.post,
  '/evaluation-system/getContentmapAbilities.php',
);

export const getEvaluationInformationTask = apiTask(
  actions.GET_EVALUATION_INFORMATION,
  api.post,
  '/evaluation-system/getEvaluationInformation.php',
);

export const getClassesOptionsTask = apiTask(
  actions.GET_CLASSES_OPTIONS,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);

export const getCurricularOptionsTask = apiTask(
  actions.GET_CURRICULAR_OPTIONS,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);

export const getUnitsOptionsTask = apiTask(
  actions.GET_UNITS_OPTIONS,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);

export const getCurricularAddAbilityOptionsTask = apiTask(
  actions.GET_CURRICULAR_ABILITY_OPTIONS,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);

export const getUnitsAddAbilityOptionsTask = apiTask(
  actions.GET_UNITS_ABILITY_OPTIONS,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);

export const checkCoordinatorPermission = apiTask(
  actions.CHECK_COORDINATOR_PERMISSION,
  api.post,
  '/evaluation-system/checkCoordinatorPermission.php',
);

export const approveAllAbilities = apiTask(
  actions.APPROVE_ALL_ABILITIES,
  api.post,
  '/evaluation-system/approveAllAbilities.php',
);

export function* watchReproveContentMapAbility() {
  while (true) {
    const { payload } = yield take(actions.REPROVE_CONTENT_MAP_HABILITY);
    yield fork(reproveContentMapAbilityTask, payload);
  }
}
export function* watchApproveContentMapAbility() {
  while (true) {
    const { payload } = yield take(actions.APPROVE_CONTENT_MAP_HABILITY);
    yield fork(approveContentMapAbilityTask, payload);
  }
}
export function* watchEditContentMapAbility() {
  while (true) {
    const { payload } = yield take(actions.EDIT_CONTENT_MAP_HABILITY);
    yield fork(editContentMapAbilityTask, payload);
  }
}
export function* watchAddContentMapAbility() {
  while (true) {
    const { payload } = yield take(actions.ADD_CONTENT_MAP_HABILITY);
    yield fork(addContentMapAbilityTask, payload);
  }
}

export function* watchGetAbilities() {
  while (true) {
    const { payload } = yield take(actions.GET_HABILITIES);
    yield fork(getAbilitiesTask, payload);
  }
}
export function* watchGetClassesOptions() {
  while (true) {
    const { payload } = yield take(actions.GET_CLASSES_OPTIONS);
    yield fork(getClassesOptionsTask, payload);
  }
}

export function* watchGetCurricularOptions() {
  while (true) {
    const { payload } = yield take(actions.GET_CURRICULAR_OPTIONS);
    yield fork(getCurricularOptionsTask, payload);
  }
}
export function* watchGetUnitsOptions() {
  while (true) {
    const { payload } = yield take(actions.GET_UNITS_OPTIONS);
    yield fork(getUnitsOptionsTask, payload);
  }
}

export function* watchGetCurricularAddAbilityOptions() {
  while (true) {
    const { payload } = yield take(actions.GET_CURRICULAR_ABILITY_OPTIONS);
    yield fork(getCurricularAddAbilityOptionsTask, payload);
  }
}
export function* watchGetUnitsAddAbilityOptions() {
  while (true) {
    const { payload } = yield take(actions.GET_UNITS_ABILITY_OPTIONS);
    yield fork(getUnitsAddAbilityOptionsTask, payload);
  }
}

export function* watchGetEvaluationInformation() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATION_INFORMATION);
    yield fork(getEvaluationInformationTask, payload);
  }
}

export function* watchCheckCoordinatorPermission() {
  while (true) {
    const { payload } = yield take(actions.CHECK_COORDINATOR_PERMISSION);
    yield fork(checkCoordinatorPermission, payload);
  }
}

export function* watchApproveAllAbilities() {
  while (true) {
    const { payload } = yield take(actions.APPROVE_ALL_ABILITIES);
    yield fork(approveAllAbilities, payload);
  }
}

// Root module saga
export function* sagas() {
  yield all([
    fork(watchGetClassesOptions),
    fork(watchGetCurricularOptions),
    fork(watchGetUnitsOptions),
    fork(watchGetAbilities),
    fork(watchGetEvaluationInformation),
    fork(watchGetCurricularAddAbilityOptions),
    fork(watchGetUnitsAddAbilityOptions),
    fork(watchAddContentMapAbility),
    fork(watchEditContentMapAbility),
    fork(watchApproveContentMapAbility),
    fork(watchReproveContentMapAbility),
    fork(watchCheckCoordinatorPermission),
    fork(watchApproveAllAbilities),
  ]);
}
